import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import * as React from 'react';
import { ERoomType } from '../../../../types/rooms';
import { CheckboxButton } from '@cian/ui-kit';
import * as style from './style.css';
import { jsx as _jsx } from "react/jsx-runtime";
/** Типы комнатностей, отсутствующие в карточках жк **/
var ADDITIONAL_ROOM_TYPES = [ERoomType.FiveRoom, ERoomType.Large, ERoomType.OpenPlan];

// eslint-disable-next-line react/display-name
export var RoomTypeFilter = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var roomsCountList = _ref.roomsCountList,
    value = _ref.value,
    onChange = _ref.onChange;
  var onClick = React.useCallback(function (currentValue) {
    return function () {
      var index = value.indexOf(currentValue);
      var result = _toConsumableArray(value);
      if (index === -1) {
        result.push(currentValue);
        if (currentValue === ERoomType.FourRoom) {
          result = [].concat(_toConsumableArray(result), ADDITIONAL_ROOM_TYPES);
        }
      } else {
        result.splice(index, 1);
        if (currentValue === ERoomType.FourRoom) {
          result = result.filter(function (val) {
            return !ADDITIONAL_ROOM_TYPES.includes(val);
          });
        }
      }
      onChange(result);
    };
  }, [onChange, value]);
  return /*#__PURE__*/_jsx("div", {
    className: style['container'],
    ref: ref,
    children: roomsCountList.map(function (room) {
      return /*#__PURE__*/_jsx(CheckboxButton, {
        disabled: !room.isAvailable,
        label: room.roomTitle,
        checked: value.includes(room.roomValue),
        onChange: onClick(room.roomValue),
        "data-testid": "RoomTypeFilter-".concat(room.roomValue)
      }, room.roomValue);
    })
  });
});